import { cloneDeep } from 'lodash'
import moment from 'moment'
import { LocationCalendars } from 'pages/my-calendars/add-calendar'

export const updateDatesRecursively = (items: LocationCalendars[], currentStoreIndex: number) => {
    const clonedItems = cloneDeep(items)

    const currentStore = clonedItems[currentStoreIndex]

    if (currentStore) {
        currentStore.additionalFields = currentStore.additionalFields.map((field, index) => {
            if (field.deliveryDate && field.orderDate) {
                const deliveryDate = moment(field.deliveryDate).startOf('day')
                const orderDate = moment(field.orderDate).startOf('day')

                if (deliveryDate.isAfter(orderDate, 'day')) {
                    // Если это первая запись, корректируем orderDate
                    if (index === 0) {
                        field.orderDate = null

                        // Если есть вторая запись, сбрасываем её даты
                        if (currentStore.additionalFields.length > 1) {
                            const nextField = currentStore.additionalFields[1]
                            nextField.deliveryDate = null
                            nextField.orderDate = null
                        }
                    }
                    // Если это вторая запись, сбрасываем только orderDate
                    else if (index === 1) {
                        field.orderDate = null
                    }
                }
            }
            return field
        })
    }

    return clonedItems
}
